

import React from 'react'
import { motion } from 'framer-motion'

import PromoTag from '@elements/store/promo-tag'

const Promo = ({ product, promo }) => {
  let currentPromo = ''

  if (promo.applyDeluxeGame && product === 'mym-deluxe-game') {
    currentPromo = promo
  }
  if (promo.applyBaseGame && product === 'mym-base-game') {
    currentPromo = promo
  }
  if (promo.dlcs) {
    promo.dlcs?.forEach((dlcPromo) => {
      // Temporary hack to add promotions to "Scorched Necropolis"
      // TODO - In Strapi, we should be able to select the "Sub-DLC" when setting a promotion on a DLC. Ex.: return "sector-1-dreadshore-arsenal" pack instead of just "sector-1-dreadshore"
      if (`${dlcPromo?.slug}-cosmetic-collection` === product || `${dlcPromo?.slug}-arsenal-pack` === product) {
        currentPromo = promo
      }
    })
  }

  return (
    currentPromo && (
      <PromoTag
        data={currentPromo}
      />
    )
  )
}

export default Promo

